import React from "react";
import * as Sentry from "@sentry/react";

function ErrorFallbackUI({ error, onReset }: { error: unknown; onReset: () => void }) {
  const message = error instanceof Error ? error.message : "An unexpected error occurred";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <button
          onClick={onReset}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => <ErrorFallbackUI error={error} onReset={resetError} />}
      beforeCapture={(scope) => {
        scope.setTag("error_category", "render_error");
        scope.setLevel("error");
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
